import { Navigate } from "react-router-dom";
import { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { getCurrentUser } from "helpers/API Calls/Auth and Profile/auth";
import { getUserSuccess, getUserFailure } from "slices/current user/reducer";
import { createSelector } from "reselect";
import { useSelector } from "react-redux";
import FullPageSpinner from "Components/UI/FullPageSpinner";
import ErrorMessage from "pages/Utility/page-error";
import { getRolePermissions, hasPermission } from "./Permissions";

  const selectProperties = createSelector(
    (state: any) => state.user,
    (user) => ({
      user: user.user,
      loading: user.loading,
      error: user.error,
      errorMsg: user.errorMsg,
      // userPermissions: user.permissions, 
    })
  );

const AuthProtected = ({children, routePermission}) => {

  const dispatch = useDispatch<any>();
  const [isLoading, setIsLoading] = useState<boolean>(true);
  const { user, error, loading, errorMsg } = useSelector(selectProperties);

  const isRouteAllowed = hasPermission(user?.user_type, routePermission || [])

  useEffect(() => {
    const getUser = async () => {
      setIsLoading(true);
        const response = await getCurrentUser(); 
        const data = await response;
        // console.log('user data', data)
        if(data.success) {
          // console.log('data', data)
          // console.log('user', data.data)
          const user_type = data.data?.user_type; 
          const permissions = getRolePermissions(user_type); 
          // console.log('permissions', permissions)
          dispatch(getUserSuccess({...data.data, permissions}));
        }else{
          dispatch(getUserFailure(data.message));
          <Navigate to={{ pathname: "/login" }} />
        }
        setIsLoading(false);
    }
    getUser(); 
  }, [dispatch]);

  if (!localStorage.getItem("token")) {
    // console.log("No token found");
    return <Navigate to="/login" />;
  }
  
  if (isLoading || loading) {
    // console.log("Loading user data...");
    return <div className="position-relative top-50"><FullPageSpinner/></div>
  }

  if (error || !user) {
    // console.log("Error loading user data:", errorMsg);
    // console.log("Error loading user data:", error);
    // console.log("Error loading user data:", user);
    return <ErrorMessage message={errorMsg}/>
  }

  if(!isRouteAllowed){
    return <Navigate to='/access-denied'/>
  }

  return (
  <>
    {children}
  </>);
};

export default AuthProtected;
